import React, { useRef, useEffect } from "react";
import {
  Box,
  IconButton,
  Alert,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ReviewCard from "./ReviewCard";

export default function ReviewCards({ reviews, issue = {}, reload, setReload }) {
      const scrollRef = useRef(null);
    
      // Auto-scroll every 8s
      useEffect(() => {
        const interval = setInterval(() => {
          if (scrollRef.current) {
            scrollRef.current.scrollBy({
              left: 320, // scroll by one card width
              behavior: "smooth",
            });
          }
        }, 8000);
        return () => clearInterval(interval);
      }, []);
    
      const scroll = (direction) => {
        if (scrollRef.current) {
          scrollRef.current.scrollBy({
            left: direction === "left" ? -320 : 320,
            behavior: "smooth",
          });
        }
      };
  return (
    <>
    {!!reviews && Array.isArray(reviews) &&  reviews.length !== 0 ?(
      <Box position="relative">
        {/* Left Arrow */}
        <IconButton
          onClick={() => scroll("left")}
          sx={{
            position: "absolute",
            top: "40%",
            left: 0,
            zIndex: 2,
            background: "#fff",
            boxShadow: 2,
          }}
        >
          <ArrowBackIosNewIcon />
        </IconButton>

        {/* Scrollable Row */}
        <Box
          ref={scrollRef}
          sx={{
            display: "flex",
            justifyContent:'flex-start',
            alignItems:'center',
            overflowX: "auto",
            scrollBehavior: "smooth",
            "&::-webkit-scrollbar": { display: "none" },
            px: 6,
            py:2,
          }}
        >
          {!!reviews && Array.isArray(reviews) && reviews.map((review) => (
            <ReviewCard
              key={review.review_id}
              review={review}
              issue={issue}
              reload={reload}
              setReload={setReload}
              // onReadMore={setSelectedReview}
            />
          ))}
        </Box>

        {/* Right Arrow */}
        <IconButton
          onClick={() => scroll("right")}
          sx={{
            position: "absolute",
            top: "40%",
            right: 0,
            zIndex: 2,
            background: "#fff",
            boxShadow: 2,
          }}
        >
          <ArrowForwardIosIcon />
        </IconButton>
      </Box>
      ):(<Alert severity="info" sx={{maxWidth:400, mx:'auto'}}>
        No reviews available yet. Be the first to submit a review!
      </Alert>)}
      </>
  )
}
